export default __webpack_public_path__ + "static/media/amiens3.e742843a.jpg";